
import { mapActions, mapGetters } from "vuex";
import filters from "~/mixins/filters";

export default {
  mixins: [filters],
  computed: {
    ...mapGetters({
      offer: "catalog/catalog-cars/offer",
      likesArray: "favorite/favorite/likesArray"
    })
  },
  methods: {
    ...mapActions({
      openModal: "modal/modal-main/openModal",
      request: "request"
    }),
    creditClick(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-credit",
        modal_title: "Заявка на автокредит",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    },
    callback(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-callback",
        modal_title: "Обратный звонок",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    },
    tradeInClick(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-tradeIn",
        modal_title: "Заявка на Trade-In",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    },
    installmentClick(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-installment",
        modal_title: "Заявка на рассрочку",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    }
  }
};
